module.exports = __webpack_public_path__ + "img/joker_1920.bdface2a.png";